import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import fakeAuth from "./fakeAuth";
import Cookies from "js-cookie";
import axios from "axios";

export interface IUseAuthProvider {
  signIn: (cb: () => Promise<Object>) => void;
  signInPhone: (cb: () => Promise<Object>) => void;
  signOut: (cb: () => void) => void;
  cookie: null | string;
  isAuthenticated: () => boolean;
  ProfileData: any;
}

const useAuthProvider = (): IUseAuthProvider => {
  const [cookie, setCookie] = useState<null | string>(null);
  const history = useNavigate();

  useEffect(() => {
    const token = Cookies.get("customer_sid");
    if (token) {
      setCookie(token);
    }
  }, []);

  const signInPhone = (cb: () => Promise<Object>) => {
    fakeAuth.signInPhone(cb).then((cookie) => {
      const token = Cookies.get("customer_sid");
      //Cookies.set("customer_sid", `${cookie}`);

      if (cookie != null) {
        Cookies.set("customer_sid", `${cookie}`);
        setCookie(`${token}`);

        history("/dashboard");
      }
    });
  };

  const signIn = (cb: () => Promise<Object>) => {
    fakeAuth.signIn(cb).then((cookie) => {
      const token = Cookies.get("customer_sid");
      //Cookies.set("customer_sid", `${cookie}`);

      axios.get("v1/profile/info").then((res) => {

        if (res.data.tariffName === "Стартовый Ямал")
          return history("/inet/activate");
      });
      
      if (cookie != null) {
        Cookies.set("customer_sid", `${cookie}`);
        setCookie(`${token}`);

        history("/dashboard");
      }
    });
  };

  const signOut = (cb: () => void) => {
    fakeAuth.signOut(() => {
      Cookies.remove("customer_sid");
      setCookie(null);
      window.location.reload();
    });
  };

  const isAuthenticated = () => {
    const token = Cookies.get("customer_sid");

    if (token) {
      return true;
    } else {
      return false;
    }
  };

  const ProfileData = () => {
    try {
      axios.get("v1/profile/info").then((res) => res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return {
    cookie,
    signIn,
    signInPhone,
    signOut,
    isAuthenticated,
    ProfileData,
  };
};

export default useAuthProvider;
